export const parseSearchParamsToSearchQuery = <
  T extends object = Record<string, string | object | boolean | undefined>,
>(
  args: T = {} as T
): T =>
  Object.entries(args).reduce<T>((acc, [key, value]) => {
    acc[key as keyof T] =
      typeof value === 'object'
        ? Object.values(value).join('').trim().length
          ? parseSearchParamsToSearchQuery<T>(value)
          : undefined
        : typeof value === 'boolean'
          ? value
          : !Number.isNaN(Number(value))
            ? Number(value)
            : value?.length
              ? value
              : undefined;
    return acc;
  }, {} as T);
